<template>
  <div>
    <div class="row">
      <div class="col-3">
        <input
          type="file"
          class="form-control"
          id="subirListaDeAcuerdos"
          @change="guardarEvento"
          accept=".pdf"
        />
      </div>
      <div class="col-3">
        <input
          type="button"
          class="form-control"
          value="Subir Lista Firmada"
          @click="guardarNuevaListaDeAcuerdos"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import store from "@/store/index";
import { ListaDeAcuerdos } from "@/components/SIFA/Comun/Modelos/ListaDeAcuerdos.js";
export default {
  data() {
    return {
      listaDeAcuerdos : new ListaDeAcuerdos(),
      eventoDocumento: null
    };
  },
  props: {
    prop_listaDeAcuerdos: ListaDeAcuerdos
  },
  components: {},
  methods: {
    guardarNuevaListaDeAcuerdos: function () {
        this.listaDeAcuerdos.cargarDatosParaFormulario(["insertar-lista-de-acuerdos"]);
        var peticion = {
          "listaDeAcuerdos": this.listaDeAcuerdos
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIFA.funciones.GuardarNuevaListaDeAcuerdos, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
            const listaDeAcuerdosId = response.data.nuevaListaDeAcuerdosId
            if (listaDeAcuerdosId && this.eventoDocumento != null && this.eventoDocumento.target.files.length > 0)
              this.agregarRutaListaDeAcuerdos(listaDeAcuerdosId);
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontré un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          comun.SeEstaCargandoInformacion(false);
        });

      },
      agregarRutaListaDeAcuerdos(listaDeAcuerdosId) {
        comun.SeEstaCargandoInformacion(true);
        // Se carga la imagen al formulario.
        var datosDelFormulario = new FormData();
        datosDelFormulario.set("ListaDeAcuerdosId", listaDeAcuerdosId);
        datosDelFormulario.set("FechaDePublicacion", this.listaDeAcuerdos.fechaDePublicacion);
        datosDelFormulario.append("document", this.eventoDocumento.target.files[0]);

        axios
          .post(
            api.conexion + api.SIFA.funciones.AgregarRutaListaDeAcuerdos,
            datosDelFormulario,
            comun.CrearElHeaderDeAutorizacion(
              this.$store.state.Login_AutorizacionOriginal,
              true
            )
          )
          .then(respuesta => {
            //console.log(respuesta);
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
            }
            comun.SeEstaCargandoInformacion(false);
          })
          .catch(excepcion => {
              console.error("encontré un error " + e);
            comun.mensajeDeAlerta(
              comun.mensajeDeError(enumeraciones.error.E500),
              null,
              null
            );
            comun.SeEstaCargandoInformacion(false);
          });
      },
      guardarEvento: function (event) {
        this.eventoDocumento = event;
      },
  },
  mounted: function mounted() {
    if (this.prop_listaDeAcuerdos)
      this.listaDeAcuerdos = this.prop_listaDeAcuerdos;
    
  },
  computed: {},
};
</script>

<style scoped>
b {
  padding-right: 3px;
}

.new-row {
  margin-top: 20px;
}

.bigtextarea {
  height: 100px;
}

</style>



// WEBPACK FOOTER //
// src/components/SIFA/Reportes/ListasDeAcuerdos/SubidorDeListaDeAcuerdos.vue